module.exports = __webpack_public_path__ + "img/food-image.d6ca740c.png";